<template>
  <div>
    <div v-if="successMessage" class="alert alert-success" role="alert">
      {{ successMessage }}
    </div>
    <form @submit.prevent>
      <div class="row">
        <div class="col-12">
          <fg-input type="number"
            placeholder="Number of Licenses to Credit"
            :class="{ 'form-group--error': $v.amount.$error }"
            v-model="$v.amount.$model">
          </fg-input>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
          <textarea placeholder="Notes"
            class="form-control"
            v-model="notes" />
          </div>
        </div>
      </div>
      <div class="text-left">
        <p-button type="info"
          :loading="isLoading"
          @click.native.prevent="creditLicenses">
          Confirm
        </p-button>
      </div>
      <div class="clearfix"></div>
    </form>
  </div>
</template>

<script>
import ziperase from '../../services/ziperase';
import { notify } from '../../services/notify';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'CreditLicensesForm',
  props: {
    pool: Object
  },
  data() {
    return {
      amount: null,
      notes: "",
      isLoading: false,
      successMessage: ""
    }
  },
  validations: {
    amount: { required }
  },
  methods: {
    async creditLicenses() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        notify().error('Please provide an amount of licenses to credit.')
        return;
      }

      this.isLoading = true;
      try {
        await ziperase.creditLicenses(this.pool.id, {
          count: this.amount,
          notes: this.notes
        });
        this.$emit('hasUpdate');
        this.$store.dispatch('licensePool/refetchTransactions');
        this.successMessage = `Success! Credited ${this.amount} licenses to the pool.`;
        this.resetForm();
      } catch (err) {
        notify().error('Failed to credit licenses.');
      }
      this.isLoading = false;
    },
    resetForm() {
      this.amount = null;
      this.notes = "",
      this.$v.$reset();
    }
  }
};
</script>
